import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Menu, MenuItem, IconButton, Box, Tooltip } from '@mui/material';
import { ReactComponent as MoreIcon } from '../../../../assets/images/more.svg';
import { ROUTES, getRouteWithParam } from '../../../../constants/routes';
import { DISABLED_CONTROL_TOOLTIP } from '../../../../constants/variables';

export const More = ({ id, openModal, setCurID, isPartner = false, status, permissions }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (e) => {
    e.preventDefault();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const isArchiveStatus = status === 'Архив';

  const MenuItemWithTooltip = (title, MenuItem) => title ? <Tooltip title={title} arrow placement="right"><Box component="span">{MenuItem}</Box></Tooltip> : MenuItem;

  const menuInner = [];
  if (isPartner) {
    if (isArchiveStatus) {
      menuInner.push(
        MenuItemWithTooltip(
          permissions.archive ? null : DISABLED_CONTROL_TOOLTIP,
          <MenuItem
            onClick={permissions.archive ? (e) => {
              setCurID(id);
              handleClose(e);
              openModal();
            } : undefined}
            sx={{ color: 'success.main' }}
            data-testid="UnarchiveTemplate"
            key={menuInner.length}
            disabled={!permissions.archive}
          >
            Вернуть в работу
          </MenuItem>
        )
      );
    } else {
      menuInner.push(
        MenuItemWithTooltip(
          permissions.edit ? null : DISABLED_CONTROL_TOOLTIP,
          <MenuItem
            component={Link}
            to={{
              pathname: getRouteWithParam(ROUTES.PARTNERS_ADD_PARTNER, ':id', id),
              state: { from: location?.pathname },
            }}
            onClick={e => {
              localStorage.setItem('partnersTab', 'PARTNERS')
              handleClose(e);
            }}
            data-testid="EditTemplate"
            key={menuInner.length}
            disabled={!permissions.edit}
          >
            Редактировать
          </MenuItem>
        )
      );
      menuInner.push(
        MenuItemWithTooltip(
          permissions.archive ? null : DISABLED_CONTROL_TOOLTIP,
          <MenuItem
            onClick={permissions.archive ? (e) => {
              setCurID(id);
              handleClose(e);
              openModal();
            } : undefined}
            sx={{ color: 'error.main' }}
            data-testid="ArchiveTemplate"
            key={menuInner.length}
            disabled={!permissions.archive}
          >
            В архив
          </MenuItem>
        )
      );
    }
  } else {
    if (!isArchiveStatus) {
      menuInner.push(
        MenuItemWithTooltip(
          permissions.edit ? null : DISABLED_CONTROL_TOOLTIP,
          <MenuItem
            component={Link}
            to={{
              pathname: getRouteWithParam(ROUTES.PARTNERS_ADD_PROMOTION, ':id', id),
              state: { from: location?.pathname },
            }}
            onClick={e => {
              localStorage.setItem('partnersTab', 'PROMOTIONS')
              handleClose(e);
            }}
            data-testid="EditTemplate"
            key={menuInner.length}
            disabled={!permissions.edit}
          >
            Редактировать
          </MenuItem>
        )
      );
    }

    menuInner.push(
      MenuItemWithTooltip(
        permissions['copy'] ? null : DISABLED_CONTROL_TOOLTIP,
        <MenuItem
          component={Link}
          to={getRouteWithParam(ROUTES.PARTNERS_COPY_PROMOTION, ':id', id)}
          onClick={e => {
            localStorage.setItem('partnersTab', 'PROMOTIONS')
            handleClose(e);
          }}
          data-testid="CopyTemplate"
          key={menuInner.length}
          disabled={!permissions['copy']}
        >
          Копировать
        </MenuItem>
      )
    );

    if (!isArchiveStatus) {
      menuInner.push(
        MenuItemWithTooltip(
          permissions.archive ? null : DISABLED_CONTROL_TOOLTIP,
          <MenuItem
            onClick={permissions.archive ? (e) => {
              setCurID(id);
              handleClose(e);
              openModal();
            } : undefined}
            sx={{ color: 'error.main' }}
            data-testid="ArchiveTemplate"
            key={menuInner.length}
            disabled={!permissions.archive}
          >
            В архив
          </MenuItem>
        )
      );
    }
  }

  return (
    <>
      <Box>
        <IconButton onClick={handleClick}>
          <MoreIcon data-testid="MoreIcon"/>
        </IconButton>

        <Menu
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button'
          }}
        >
          {[...menuInner]}
        </Menu>
      </Box>
    </>
  );
};

More.propTypes = {
  id: PropTypes.any,
  openModal: PropTypes.func,
  setCurID: PropTypes.func,
  isPartner: PropTypes.bool,
  status: PropTypes.any,
  permissions: PropTypes.object
};
